module.exports = __webpack_public_path__ + "img/8.70369d21.jpg";